/**
 * UUIDv7 — time-ordered identifiers, generated on the client.
 *
 * Client generation matters: items must be creatable offline (FR-10.1), so the
 * client cannot wait for a server-assigned id. Time ordering means ids sort by
 * creation, which keeps list queries cheap, and the 74 bits of randomness make
 * collision between two offline devices not a practical concern (sync correctness
 * case 10 in docs/design/03-sync-protocol.md).
 */
export function uuidv7(now = Date.now()) {
    const bytes = new Uint8Array(16);
    crypto.getRandomValues(bytes);
    // 48-bit big-endian millisecond timestamp
    bytes[0] = (now / 2 ** 40) & 0xff;
    bytes[1] = (now / 2 ** 32) & 0xff;
    bytes[2] = (now / 2 ** 24) & 0xff;
    bytes[3] = (now / 2 ** 16) & 0xff;
    bytes[4] = (now / 2 ** 8) & 0xff;
    bytes[5] = now & 0xff;
    // version 7, variant 10
    bytes[6] = (bytes[6] & 0x0f) | 0x70;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
/** Milliseconds encoded in a UUIDv7, for assertions and ordering checks. */
export function uuidv7Timestamp(id) {
    return parseInt(id.replace(/-/g, '').slice(0, 12), 16);
}
//# sourceMappingURL=ids.js.map